import { keysToCamelCase } from 'shared/utils/api'

const adaptSignUpConfig = data => keysToCamelCase(data)

export {
  adaptSignUpConfig,
}
